<template>
  <!--新增商品-->
  <div style="background-color: #fff">
    <x-addEdit
      ref="addEdit"
      :itemLayout="itemLayout"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
    >
      <template slot="docContent" slot-scope="{formItem}">
        <a-form-item
          :label="formItem.label"
          has-feedback
          v-bind="itemLayout">
          <!-- <div id="editor"></div> -->
          <wangedit ref='wangedit'></wangedit>
        </a-form-item>
      </template>

      <template slot="attributeList">
        <cardHead :formItem="{cardHead: '价格库存'}" :formIndex="5"/>
        <a-form-item label="商品规格" class="attribute-list goods-attrs">

          <a-button @click="addAttribute" type="link" size="small">添加规格</a-button>
          <div v-for="(item, index) of attrsList" :key="index">
            <a-form-item label="规格名" has-feedback v-bind="{ labelCol: {span: 3}, wrapperCol: {span: 20} }">
              <a-row tyle="flex">
                <a-col span="10" style="width: 160px">
                  <a-input v-model.trim="item.name" maxLength=20 placeholder="请输入规格名"/>
                </a-col>
                <a-col span="10" style="width: 150px">
                  <a-button @click="delAttribute(item, index)"
                            style="margin-left: 5px; padding: 0; color: #f5222d;" type="link" size="small">删除规格
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>

            <a-form-item label="规格值" v-for="(ele, i) of item.attrVal" :key="i"
                         v-bind="{ labelCol: {span: 3}, wrapperCol: {span: 21} }">
              <a-row type="flex">
                <a-col span="10" style="width: 160px">
                  <a-input v-model.trim="ele.value" maxLength=20 placeholder="请输入规格值"/>
                </a-col>
                <a-col v-if="i===0" style="margin-left: 5px; width: 26px">
                  <a-icon @click="addAttrsVal(index)" type="plus-circle"
                          :style="{fontSize: '18px', color: '#1890ff', cursor: 'pointer'}"/>
                </a-col>
                <a-col style="width: 26px">
                  <a-icon v-if="item.attrVal.length > 1" @click="delAttrsVal(index, i)" type="close-circle"
                          :style="{fontSize: '18px', color: '#f5222d', cursor: 'pointer'}"/>
                </a-col>
              </a-row>
            </a-form-item>
          </div>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 8, offset: 2 }">
          <a-button @click="updateSku" type="primary">更新sku</a-button>
        </a-form-item>

        <a-form-item label="规格明细" class="attribute-list">
          <x-tabula
            ref="table"
            rowKey="key"
            :dataSource="skuDataSource"
            :columns="skuColumns"
            :rowSelection="false"
          >
            <template slot="opt_point" slot-scope="{row}">
              <a-input-number
                style="width: 110px"
                @change="e => skuPointChange(e, row, 'point')"
                v-model.number="row.point"
                :min="0"
                placeholder="兑换价"
              ></a-input-number>
            </template>

            <template slot="opt_stock" slot-scope="{row}">
              <a-input-number
                style="width: 110px"
                @change="e => skuPointChange(e, row, 'stock')"
                v-model.number="row.stock"
                :min="0"
                placeholder="库存"
              ></a-input-number>
            </template>
          </x-tabula>
        </a-form-item>

      </template>
    </x-addEdit>

    <!--选择卡券的弹窗-->
    <a-modal
      :title="this.productTitle"
      :visible="visible"
      @cancel="closeModal"
      @ok="selectConfirm"
      v-bind="$store.state.modalConfig"
    >
      <x-tabula
        ref="table"
        rowKey="couponId"
        @handleSelectChange="handleSelectChange"
        :dataSource="dataSource"
        :searchList="searchList"
        :columns="columns"
        :searchParams.sync="searchParams"
        :listApi="listApi"
        :rowSelection="true"
      >
        <template slot="opt_num" slot-scope="{row}">
          <span>{{ `${row.sale}/${row.stock}` }}</span>
        </template>
        <template slot="opt_cnum" slot-scope="{row}">
          <span>{{ `${row.receivedNum}/${row.publishNum}` }}</span>
        </template>
        <template slot="opt_wnum" slot-scope="{row}">
          <span>{{ `${row.useNum}/${row.publishNum}` }}</span>
        </template>
      </x-tabula>
    </a-modal>
  </div>
</template>

<script>
import { cardHead } from 'ant-design-vue-admin-x';
import Common from '@/utils/common';
import wangedit from '@/components/package/wangedit.vue';
import { fetchSelect } from '@/utils/mixins';

export default {
  name: 'addEditGoods',
  mixins: [fetchSelect],
  components: { cardHead, wangedit },
  data () {
    // 商品类型1.实物 2 卡券
    const goodsType = [
      { label: '实物', value: 1 },
      { label: '卡券', value: 2 }
    ];
    const maxLen = { max: 9, message: '最多9位数字' };
    return {
      productType: undefined,
      productTitle: undefined,
      isCoupon: false,
      choiceCouponId: '',
      changeIndex: 0,
      attrsChanged: false,
      detailCouponId: '',
      itemLayout: {
        labelCol: { span: 2 },
        wrapperCol: { span: 10 }
      },
      attrsList: [],
      skuDataSource: [],
      dynamicColumns: [],
      staticColumns: [
        { title: '兑换价(积分)', dataIndex: 'point', align: '', width: '', scopedSlots: { customRender: 'point' } },
        { title: '库存', dataIndex: 'stock', align: '', width: '', scopedSlots: { customRender: 'stock' } }
      ],

      formList: [
        {
          label: '商品类型',
          inputType: 'select',
          cardHead: '基本信息',
          options: [],
          handle: e => this.goodsTypeChange(e),
          placeholder: '请选择商品类型',
          props: ['type', {
            initialValue: '1',
            rules: [{ required: true, message: '请选择商品类型' }]
          }]
        },
        { // 卡券才有
          isShow: false,
          label: '选择卡券',
          inputType: 'input',
          options: [],
          click: this.chooseCoupon,
          placeholder: '请选择卡券',
          readOnly: true,
          props: ['couponName', {
            rules: [{ required: true, message: '请选择卡券' }]
          }]
        },
        {
          label: '商品分组',
          inputType: 'select',
          mode: 'multiple',
          options: [],
          handle: '',
          placeholder: '请选择(最多三个)',
          props: ['groupId', {
            rules: [{ required: true, message: '请选择商品分组' }]
          }]
        },
        {
          label: '商品名称',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入商品名称',
          props: ['name', {
            rules: [
              { required: true, message: '请输入商品名称' },
              { min: 1, max: 20, message: '商品名称最多20位' }
            ]
          }]
        },
        {
          label: '副标题',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入副标题',
          props: ['subTitle', {
            rules: [{ min: 1, max: 20, message: '副标题最多20位' }]
          }]
        },
        {
          label: '商品主图',
          inputType: 'upload',
          options: [],
          handle: '',
          placeholder: '',
          // extra: '图片大小不超过5MB，最多添加5张，用于商品列表和商品订单页面的展示，可拖拽调整顺序',
          extra: '图片大小不超过5MB，最多添加5张，用于商品列表和商品订单页面的展示',
          fileList: [],
          beforeHandle: Common.uploadBeforeHandle,
          uploadParam: {
            url: '/common/upload',
            iconUrl: 'pic',
            limit: 5,
            listType: 'picture',
            accept: this.$store.state.imgAccept
          },
          props: ['pic', {
            rules: [{ required: true, message: '请选择商品主图' }]
          }]
        },
        { // 实物才有
          slot: 'attributeList',
          label: '商品规格',
          inputType: 'input',
          extra: '最多3个',
          props: ['attributeList', {
            rules: []
          }]
        },
        {
          label: '库存',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入库存',
          props: ['stock', {
            rules: [
              { required: true, message: '请输入库存' },
              { pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger },
              maxLen
            ]
          }]
        },
        {
          label: '兑换价',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入兑换价',
          props: ['point', {
            rules: [
              { required: true, message: '请输入兑换价' },
              { pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger },
              maxLen
            ]
          }]
        },
        {
          label: '划线价',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入划线价',
          props: ['originalPoint', {
            rules: [{ pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger }, maxLen]
          }]
        },
        {
          label: '使用规则',
          inputType: 'textarea',
          cardHead: '商品详情',
          options: [],
          handle: '',
          placeholder: '请输入使用规则',
          props: ['description', {
            rules: []
          }]
        },
        {
          slot: 'docContent',
          label: '图文详情',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '',
          props: ['detailHtml', {
            rules: []
          }]
        },
        {
          label: '订单审核',
          checkboxLabel: '需要审核',
          inputType: 'checkbox',
          cardHead: '购买限制',
          options: [],
          handle: '',
          placeholder: '',
          props: ['isVerify', {
            valuePropName: 'checked',
            rules: []
          }]
        }
      ],
      formKey: {
        type: undefined,
        couponName: undefined,
        groupId: undefined,
        name: undefined,
        subTitle: undefined,
        pic: undefined,
        attributeList: undefined,
        stock: undefined,
        point: undefined,
        originalPoint: undefined,
        description: undefined,
        detailHtml: undefined,
        isVerify: undefined
      },
      addParam: {
        url: '/pm/product',
        reqHandle: this.reqHandle, // addParam、editParaM都会执行 reqHandle方法
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/pm/product/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/pm/product/',
        resHandle: this.detailResHandle
      },

      /** 选择卡券弹窗 */
      selectedCoupon: [],
      visible: false,
      searchParams: {
        name: undefined
        // status: 1
      },
      searchList: [
        { props: ['name'], placeholder: '卡券名称', options: [], inputType: 'input' }
      ],
      columns: [
        { title: '卡券名称', dataIndex: 'name', align: '', width: '' },
        { title: '已发放/总数', dataIndex: '', align: '', width: '', scopedSlots: { customRender: 'num' } },
        { title: '有效期', dataIndex: 'expireTime', align: '', width: '' }
      ],
      columnsA: [
        { title: '卡券名称', dataIndex: 'name', align: '', width: '' },
        { title: '已发放/总数', dataIndex: '', align: '', width: '', scopedSlots: { customRender: 'num' } },
        { title: '有效期', dataIndex: 'expireTime', align: '', width: '' }
      ],
      columnsB: [
        { title: '本地优惠券名称', dataIndex: 'couponName', align: '', width: '' },
        { title: '已发放/总数', dataIndex: '', align: '', width: '', scopedSlots: { customRender: 'cnum' } },
        { title: '有效期', dataIndex: 'expireTime', align: '', width: '' }
      ],
      columnsC: [
        { title: '批次名称', dataIndex: 'stockName', align: '', width: '' },
        { title: '已发放/总数', dataIndex: '', align: '', width: '', scopedSlots: { customRender: 'wnum' } },
        { title: '有效期', dataIndex: 'availableTime', align: '', width: '' }
      ],
      dataSource: [],
      listApi: {
        url: '/pm/coupon/listAllEnable',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  computed: {
    skuColumns () {
      return this.dynamicColumns.concat(this.staticColumns);
    }
  },
  watch: {
    skuDataSource: {
      deep: true,
      handler (val) {
        let price = this.formList.find(item => item.props && item.props[0] === 'point');
        let stock = this.formList.find(item => item.props && item.props[0] === 'stock');
        if (!val.length) { // 判断库存、兑换价的禁用
          stock.disabled = false;
          price.disabled = false;
          return false;
        } else {
          stock.disabled = true;
          price.disabled = true;
        }
        let total = 0;
        let priceArr = [];
        val.forEach(item => {
          item.stock !== undefined && item.stock !== '' && (total += item.stock);
          item.point !== undefined && item.point !== '' && priceArr.push(item.point);
        });
        priceArr.sort((a, b) => a - b);
        this.$refs.addEdit.form.setFieldsValue({ stock: total, point: priceArr[0] }); // 根据sku明细计算总库存、价格
      }
    },
    attrsList: {
      deep: true,
      handler (val) {
        if (this.$route.query.id) {
          this.changeIndex > 0 && (this.attrsChanged = true);
          this.changeIndex++;
        } else {
          this.attrsChanged = true;
        }
      }
    }
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.$get({
        url: '/pm/group/treeSelect',
        params: {}
      }).then(({ data }) => {
        let group = this.formList.find(item => item.props && item.props[0] === 'groupId');
        group && (group.options = data);
      });
      this.dictionarySelect([{
        query: 'comu_activity_product_type',
        handle: (data) => {
          this.formList[0].options = data;
        }
      }]);
    },
    skuPointChange (event, row, key) {
      let value = String(event);
      if (value.includes('.')) {
        row[key] = Math.floor(value);
      }
      if (event < 0) {
        row[key] = 0;
      }
      if (value && value.length > 9) {
        row[key] = value.slice(0, 9);
      }

      typeof row[key] === 'string' && (row[key] = Number(row[key]));
    },
    /** 商品类型选择事件 */
    goodsTypeChange (e, type) {
      this.selectedCoupon = [];
      this.productType = e;
      // 实物：1， 卡券：2
      let coupon = this.formList.find(item => item.props && item.props[0] === 'couponName');
      let attrList = this.formList.find(item => item.props && item.props[0] === 'attributeList');
      let stock = this.formList.find(item => item.props && item.props[0] === 'stock');
      let typeItem = this.listFindItem(this.formList, 'type');
      this.$refs.addEdit.form.resetFields(['stock', 'point', 'couponName']);

      type === 'detail' && (typeItem.disabled = true);
      if (e == 1) {
        stock.disabled = false;
        stock.cardHead = undefined;
        coupon.isShow = false;
        attrList.isShow = true;
        this.isCoupon = false;
      } else if (e == 2) {
        stock.disabled = true;
        stock.cardHead = '价格库存';
        coupon.isShow = true;
        attrList.isShow = false;
        type === 'detail' && (coupon.disabled = true);
        this.formList[1].label = '选择卡券';
        this.formList[1].placeholder = '请选择卡券';
        this.searchList[0].placeholder = '选择卡券';
        this.formList[1].props[1].rules[0].message = '选择卡券';
        this.isCoupon = false;
        this.listApi.url = '/pm/coupon/listAllEnable';
        this.columns = this.columnsA;
        this.productTitle = '卡券';
      } else if (e == 4) {
        stock.disabled = true;
        stock.cardHead = '价格库存';
        coupon.isShow = true;
        attrList.isShow = false;
        type === 'detail' && (coupon.disabled = true);
        this.formList[1].label = '本地优惠券';
        this.formList[1].placeholder = '请选择本地优惠券';
        this.formList[1].props[1].rules[0].message = '请选择本地优惠券';
        this.searchList[0].placeholder = '选择本地优惠券';
        this.isCoupon = true;
        this.listApi.url = '/local/coupon/treeSelect';
        this.columns = this.columnsB;
        this.productTitle = '本地优惠券';
      } else if (e == 5) {
        stock.disabled = true;
        stock.cardHead = '价格库存';
        coupon.isShow = true;
        attrList.isShow = false;
        type === 'detail' && (coupon.disabled = true);
        this.formList[1].label = '微信代金券';
        this.formList[1].placeholder = '请选择微信代金券';
        this.formList[1].props[1].rules[0].message = '请选择微信代金券';
        this.searchList[0].placeholder = '选择微信代金券';
        this.isCoupon = true;
        this.listApi.url = '/pm/wx/coupon/listAllEnable';
        this.columns = this.columnsC;
        this.productTitle = '微信代金券';
      }
    },

    /** 提示更新sku */
    updateSku () {
      if (!this.verifyAttrs()) { return; }
      this.$confirm({
        title: '确定要更新商品规格明细？这将会清空已输入的兑换价、库存',
        centered: true,
        onOk: () => {
          this.attrsChanged = false;
          this.createSku();
        }
      });
    },
    /** 创建（sku） */
    createSku () {
      const columns = [];
      this.attrsList.forEach((item, index) => {
        columns.push({ title: item.name, dataIndex: `sp${index + 1}` });
      });
      this.dynamicColumns = columns;

      let list = this.attrsList.map(item => {
        const attrVal = [];
        item.attrVal.forEach((el) => {
          attrVal.push(el.value);
        });
        return attrVal;
      });
      let arr = [];
      if (list && list.length) {
        arr = this.cartesian(list);
      }

      let sku = arr.map((item, index) => {
        let obj = { key: index };
        item.forEach((ele, index) => {
          obj[`sp${index + 1}`] = ele;
        });
        return obj;
      });
      this.skuDataSource = sku;
    },
    cartesian (elements) {
      if (!Array.isArray(elements)) {
        throw new TypeError();
      }

      let end = elements.length - 1;
      let result = [];

      function addTo (curr, start) {
        let first = elements[start];
        let last = (start === end);
        for (let i = 0; i < first.length; ++i) {
          let copy = curr.slice();
          copy.push(first[i]);
          if (last) {
            result.push(copy);
          } else {
            addTo(copy, start + 1);
          }
        }
      }

      if (elements.length) {
        addTo([], 0);
      } else {
        result.push([]);
      }

      return result;
    },

    /** 添加（商品规格） */
    addAttribute () {
      const len = this.attrsList.length;
      if (len === 3) {
        this.$message.error('最多三个商品规格');
        return;
      }
      this.attrsList.push({ name: undefined, attrVal: [{ value: undefined }] });
    },
    /** 删除（商品规格） */
    delAttribute (item, index) {
      this.attrsList.splice(index, 1);
    },
    /** 添加（规格值） */
    addAttrsVal (index) {
      this.attrsList[index].attrVal.push({ value: undefined });
    },
    /** 删除（规格值） */
    delAttrsVal (index, i) {
      let attrVal = this.attrsList[index].attrVal;
      if (attrVal.length === 1) { return; }
      attrVal.splice(i, 1);
    },
    /** 选择卡券 */
    chooseCoupon () {
      this.visible = true;
    },
    /** 关闭弹窗（选择卡券） */
    closeModal () {
      this.searchParams.name = undefined;
      this.selectedCoupon = [];
      this.visible = false;
    },
    /** 确定选择卡券 */
    selectConfirm () {
      if (this.productType == 2) {
        if (this.selectedCoupon.length > 1) {
          this.$message.error('最多只能关联一张卡券');
        } else {
          let couponItem = this.selectedCoupon[0];
          let str = `${couponItem.name} 有效期：${couponItem.expireTime}`;
          this.$refs.addEdit.form.setFieldsValue({ couponName: str, stock: couponItem.stock - couponItem.sale });
          this.choiceCouponId = couponItem.couponId; // 满足只选择一个且点击确定了才赋值
          this.searchParams.name = undefined;
          this.visible = false;
        }
      } else if (this.productType == 4) {
        if (this.selectedCoupon.length > 1) {
          this.$message.error('最多只能关联一张本地优惠券');
        } else {
          let couponItem = this.selectedCoupon[0];
          let str = `${couponItem.couponName} 有效期：${couponItem.expireTime}`;
          this.$refs.addEdit.form.setFieldsValue({ couponName: str, stock: couponItem.stock});
          this.choiceCouponId = couponItem.couponId; // 满足只选择一个且点击确定了才赋值
          this.searchParams.name = undefined;
          this.visible = false;
        }
      } else if (this.productType == 5) {
        if (this.selectedCoupon.length > 1) {
          this.$message.error('最多只能关联一张本地优惠券');
        } else {
          let couponItem = this.selectedCoupon[0];
          let str = `${couponItem.stockName} 有效期：${couponItem.availableTime}`;
          this.$refs.addEdit.form.setFieldsValue({ couponName: str, stock: couponItem.stock});
          this.choiceCouponId = couponItem.couponId; // 满足只选择一个且点击确定了才赋值
          this.searchParams.name = undefined;
          this.visible = false;
        }
      }
      this.selectedCoupon = [];
    },
    /** 选择卡券事件 只能选择一个卡券 */
    handleSelectChange (rows) {
      if (rows && rows.length > 1) {
        this.$message.error('最多只能关联一张卡券');
      }
      this.selectedCoupon = rows;
    },

    /** 详情数据处理 */
    detailResHandle (res) {
      this.goodsTypeChange(res.type, 'detail');
      res.isVerify = res.isVerify === 1;

      if (res.type == 1) {
        let columns = [];
        if (res.attributeList && res.attributeList.length) { // 如果返回数据有商品规格
          this.attrsList = res.attributeList.map((item, index) => {
            columns.push({ title: item.name, dataIndex: `sp${index + 1}` });

            const attrVal = item.value && item.value.map(el => ({ value: el && el.replace(/\s+/g, '') }));
            return { name: item.name, attrVal: attrVal };
          });
          this.dynamicColumns = columns;
          this.skuDataSource = res.skuList;
        }
      } else {
        this.detailCouponId = res.couponId;
      }

      if (res.detailHtml && res.detailHtml !== '<p><br></p>') {
        // this.editor.txt.html(res.detailHtml); // 设置editor内容
        // this.editorVal = res.detailHtml;
        // this.editor.change();
        this.$refs.wangedit.html = res.detailHtml;
      }

      return res;
    },
    /** 提交前处理 */
    reqHandle (param) {
      if (this.attrsChanged === true) {
        this.$message.error('请更新sku');
        return false;
      }
      this.editorVal = this.$refs.wangedit.html;
      if (this.editorVal) {
        param.detailHtml = this.editorVal;
      }
      param.isVerify = param.isVerify === true ? 1 : 0;

      if (param.type == 1) { // 商品类型: 1 实物; 2 卡券
        let sku = this.skuDataSource && this.skuDataSource.map(item => item);
        const skuAll = sku.every(item => {
          console.log('point stock: ', item.point, item.stock);
          return (item.point || item.point === 0) && (item.stock || item.stock === 0);
        });
        if (!skuAll) {
          this.$message.error('规格明细 数据不完整');
          return;
        }
        const attrs = this.verifyAttrs();
        if (attrs === false) { return; }

        param.attributeList = attrs;
        param.skuList = sku;
      } else {
        if (this.choiceCouponId) { // 新增用新值，否则用详情的旧值
          param.couponId = this.choiceCouponId;
        } else if (this.detailCouponId) {
          param.couponId = this.detailCouponId;
        }
        delete param.attributeList;
        delete param.skuList;
      }

      return param;
    },
    /** 验证商品规格完整性 */
    verifyAttrs () {
      let attrs = this.attrsList && JSON.parse(JSON.stringify(this.attrsList)).map(item => {
        item.value = item.attrVal.map(ele => ele.value);
        delete item.attrVal;
        return item;
      });

      const allAttr = this.attrsList.every(item => {
        console.log('item.name: ', item.name);
        return item.name;
      });
      const allVal = attrs.every(item => {
        console.log('item.value: ', item.value);
        if (item.value.length) {
          return item.value.every(item => item);
        }
        return true;
      });
      if (!allAttr || !allVal) {
        this.$message.error('商品规则 数据不完整');
        return false;
      }

      return attrs;
    },

    /** change（ 规格名 ） */
    attrNameChange (e, index) {
      let dataIndex = this.dynamicColumns[index].dataIndex;
      dataIndex = dataIndex.includes('sp') && Number(dataIndex.slice(-1));
      if (index + 1 === dataIndex) {
        this.dynamicColumns[index].title = e.target.value;
      }
    },
    /** change（规格值 ） */
    attrValChange (e) {
      this.createSku();
    },
    /** 处理规格明细 更新 */
    handleDiffer (data) {
      data.forEach(item => {
        this.skuDataSource.forEach(ele => {
          if (item.productName === ele.productName) {
            item.point = ele.point;
            item.stock = ele.stock;
          }
        });
      });
    },
    /** 执行删除（商品规格） */
    handleDelAttribute (item, index) {
      let columnIndex = this.dynamicColumns.findIndex(el => el.title === item.name);
      this.dynamicColumns.splice(columnIndex, 1);
      this.dynamicColumns.length === 1 && (this.dynamicColumns[0].dataIndex = 'sp1');

      this.updateSkuData(item);
    },
    /** 更新sku列表 生成笛卡尔积 */
    updateSkuData (item) {
      if (this.attrsList.length < 2) {
        if (this.skuDataSource.length) {
          this.attrsList[0].attrVal.map((item) => {
            let obj = {};
            this.skuDataSource.forEach((el) => {
              for (let key in el) {
                if (item.value === el[key]) {
                  obj = { sp1: item.value, point: el.point, stock: el.stock, productName: `${item.value}-${undefined}` };
                }
              }
            });
            return obj;
          });
        } else {
          let data = this.attrsList[0].attrVal.map((item) => {
            return { sp1: item.value, point: undefined, stock: undefined, productName: `${item.value}-${undefined}` };
          });
          this.skuDataSource = data;
        }
      } else {
        this.createSku();
      }
    }
  }
};
</script>

<style lang="scss">
.attribute-list {
  > .ant-form-item-control-wrapper {
    padding: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
}
.goods-attrs {
  margin-bottom: 6px;
}
</style>
